<template>
  <div class="itt-img-miniature">
    <div ref="imgContainer" :class="{clicked: selected}" @click="selectImg()" class="img-container" :style="{height: height + 'px'}">
      <div class="loader" :class="{visible: !loader}">
        <v-icon>mdi-loading mdi-spin</v-icon>
      </div>
      <img ref="imgDisplay" @load="loaded()" :src="element.file_url" alt="">
    </div>
    <div class="name-container">
      <button :title="element.name" :class="{clicked: selected}" class="name-image blue-hover" @click="$emit('clicked', element)">{{name}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    update: String,
    element: Object,
  },
  watch: {
    update() {
      this.ajustSize();
    },
    heightProportion() {
      this.ajustSize();
    },
  },
  mounted() {
    this.ajustSize();
    window.addEventListener('resize',this.ajustSize);
  },
  computed: {
    selected() {
      let selects = this.$store.getters["image/getMultiSelectImg"];
      let selected = selects.includes(this.element.uuid)
      return selected;
    },
    heightProportion() {
      let direction = this.$store.getters["image/getDisplayDirection"];
      if (direction == 'horizontal')
        return 0.65;
      else
        return 1.25;
    },
    name() {
      let name = this.element.name;
      let lastDot = name.lastIndexOf('.');
      name = name.slice(0, lastDot);
      return name
    }
  },
  data() {
    return {
      height: '',
      loader: true
    }
  },
  methods: {
    ajustSize() {
      let imgMini = this.$refs.imgContainer;
      if (!imgMini)
        return;
      let width = parseInt(getComputedStyle(imgMini).width);
      this.height = (width * this.heightProportion);
      let proportionOriginalImg = this.element.height / this.element.width;
      if (proportionOriginalImg < this.heightProportion) {
        this.$refs.imgDisplay.style.height = this.height - 4 + 'px';
        this.$refs.imgDisplay.style.width = 'auto';
      } else {
        this.$refs.imgDisplay.style.height = 'auto';
        this.$refs.imgDisplay.style.width = width - 4 + 'px';
      }
    },
    selectImg() {
      if (this.selected)
        this.$store.commit("image/unsetMultiSelectImg", this.element.uuid);
      else this.$store.commit("image/setMultiSelectImg", this.element.uuid)
    },
    loaded() {
      this.loader = false;
    }
  }
}
</script>

<style lang="sass">
$selected: #f1e341
$main-border: #989898
.itt-img-miniature 
  .img-container
    border: 2px solid $main-border
    background-position: center //!
    background-size: cover //!
    position: relative
    overflow: hidden
    transition: all ease .3s
    &:hover
      border-color: darken($selected, 20%)
      box-shadow: black 0px 0px 15px !important;
    &.clicked 
      border-color: $selected
    img 
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
  .name-container
    text-align: center
    margin-top: .5rem
    .name-image
      margin: 0 5%
      max-width: 90%
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
      // word-break: break-all
      color: #b2b2b2
      font-size: 1.3rem
      background-color: #30302e
      padding: .1rem .8rem
      text-transform: uppercase
      transition: all ease .3s
      &:focus
        outline: 0
      &:hover
        // color: #6eb6a8
        box-shadow: 0 0 10px black
      &.clicked 
        color: $selected
  position: relative
  .loader 
    position: absolute
    top: 0
    bottom: 0
    width: 100%
    background: #171717
    z-index: 2
    display: flex 
    align-items: center
    opacity: 1
    transition: all ease .4s
    &.visible 
      opacity: 0
    i 
      margin: auto
      font-size: 2rem
</style>
